import { create } from "zustand";

export const DEFAULT_TOTAL_TOYS = 5;

export type ToyCollectionState = {
	totalToys: number;
	collectedCount: number;
	registeredToyIds: Set<string>;
	collectedToyIds: Set<string>;
	registerToy: (id: string) => void;
	collectToy: (id: string) => boolean;
	isToyCollected: (id: string) => boolean;
	resetCollection: () => void;
};

export const useToyCollection = create<ToyCollectionState>((set, get) => ({
	totalToys: DEFAULT_TOTAL_TOYS,
	collectedCount: 0,
	registeredToyIds: new Set<string>(),
	collectedToyIds: new Set<string>(),
	registerToy: (id: string) => {
		if (!id) return;

		set((state) => {
			if (state.registeredToyIds.has(id)) {
				return {};
			}

			const registeredToyIds = new Set(state.registeredToyIds);
			registeredToyIds.add(id);

			const totalToys = Math.max(DEFAULT_TOTAL_TOYS, registeredToyIds.size);

			return { registeredToyIds, totalToys };
		});
	},
	collectToy: (id: string) => {
		if (!id) return false;

		const { collectedToyIds } = get();
		if (collectedToyIds.has(id)) {
			return false;
		}

		const nextCollected = new Set(collectedToyIds);
		nextCollected.add(id);

		set({
			collectedToyIds: nextCollected,
			collectedCount: nextCollected.size,
		});

		return true;
	},
	isToyCollected: (id: string) => get().collectedToyIds.has(id),
	resetCollection: () => {
		set((state) => ({
			collectedToyIds: new Set<string>(),
			collectedCount: 0,
			totalToys: Math.max(DEFAULT_TOTAL_TOYS, state.registeredToyIds.size),
		}));
	},
}));

export const getToyProgress = () => {
	const { collectedCount, totalToys } = useToyCollection.getState();
	if (totalToys <= 0) return 0;
	return collectedCount / totalToys;
};
